<app-create-update-default [formGroup]="formGroup" [service]="service" [id]="id"
                           [findOneService]="findOneService"
                           [buildPayload]="buildPayload" (entityLoaded)="entityLoaded($event)"
                           (entitySaved)="onEntitySaved($event)" [inDialog]="inDialog">
  <ng-template template-content>
      <app-loading *ngIf="loading"></app-loading>
      <ion-card *ngIf="!loading">
          <ion-card-content>
            <ion-grid>
              <ion-row>
                <ion-col size="12" sizeLg="6" sizeXl="3">
                  <h3 class="label">Libellé</h3>
                  <div class="input" style="display: flex;" required>
                    <ion-input class="ion-text-left border-bottom-input" formControlName="label"></ion-input>
                  </div>
                </ion-col>
                <ion-col size="12" sizeLg="6" sizeXl="3" *ngIf="showParentInput">
                  <h3 class="label">Parent</h3>
                  <div class="input" style="display: flex;">
                    <app-lov-values-select-filter style="width: 100%;" [lovListName]="lovListName" [hideChildren]="true" [parentFormGroup]="formGroup" parentFormControlName="parentValueId" [lovValuesToIgnore]="lovValue? [lovValue?.summary]: []"></app-lov-values-select-filter>
                  </div>
                </ion-col>
                <ion-col size="12" sizeLg="6" sizeXl="3" *ngIf="showParamInput">
                  <h3 class="label">{{paramLabel ? paramLabel : 'Param'}}</h3>
                  <div class="input" style="display: flex;">
                    <ion-input *ngIf="paramInputType === 'positiveNumber'" formControlName="param" type="number"></ion-input>
                    <ion-input *ngIf="paramInputType !== 'positiveNumber'" formControlName="param" type="text"></ion-input>
                  </div>
                </ion-col>
                <ion-col size="12" *ngIf="showCommentInput">
                  <h3 class="label">Commentaire</h3>
                  <div class="input" style="display: flex;">
                    <ion-textarea class="ion-text-left border-bottom-input" formControlName="comment" rows="5"></ion-textarea>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>
  </ng-template>
</app-create-update-default>
